export interface SkillCategory {
  id?: number;
  name?: string;
  parent_category_id?: number; // Parent category id
  key?: number;
}
